import React from 'react';
import { getAuth } from "firebase/auth";
import { doc, updateDoc } from 'firebase/firestore';
import { db } from './Firebase';
import styled from 'styled-components';
import { ImExit } from "react-icons/im";

const ImExitButton = styled(ImExit)`
  font-size: 1.5em;
  cursor: pointer;
  color: #404040;
  &:hover {
    color: #a7a7a7;
  }
  &.imExitDark {
    color: white;
    &:hover {
      color: #a7a7a7;
    }
  }
`;

const CerrarSesion = ({isDarkMode, setUsuario}) => {
  const auth = getAuth();

  const handleClick = async () => { 
    const userRef = doc(db, 'users', auth.currentUser.uid);
    await updateDoc(userRef, { state: 'offline' });
    auth.signOut().then(() => {
      setUsuario(null);
    });
  };

  return (
    <ImExitButton
      onClick={handleClick}
      className={isDarkMode ? "imExitDark" : ""}
    />
  );
};

export default CerrarSesion;